export const categoryHeadersData = [
  {
    text: 'Name',
    value: 'name'
  },
  {
    text: 'Pre-Exercise Instructions',
    value: 'description'
  },
  {
    text: 'In-Exercise Instructions',
    value: 'exercise_description'
  }
];
